import React, { Component } from "react";

import "./AgreeCookies.css";

class AgreeCookies extends Component {
  state = {
    hasCookie: false,
    IsAccept: false,
  };
  setCookie = () => {
    document.cookie = "agreetoacookie=true";
  };

  Okcookies = () => {
    document.cookie = "agreetoacookie=true";
    document.getElementById("cf-root").remove();
  };
  Deny = () => {
    document.cookie = "agreetoacookie=false";
    document.getElementById("cf-root").remove();
  };
  adjust = () => {
    document.getElementById("cf-root").remove();
  };

  componentDidMount() {
    var document_cookies = document.cookie;
    document_cookies = document_cookies.split(";");
    // console.log(document_cookies);
    for (var i in document_cookies) {
      var patt = new RegExp("agreetoacookie");
      var res = patt.test(document_cookies[i]);
      if (res == true) {
        let temp = document_cookies[i].split("=");
        this.setState({
          IsAccept: temp[1] === "true",
          hasCookie: true,
        });
      }
    }
  }
  render() {
    let html = "";
    html = (
      <div id="cf-root" className="cookiefirst-root">
        <div translate="yes" className="cf2CeT notranslate cf2DrG">
          <div
            data-cookiefirst-widget="banner"
            dir="ltr"
            className="cf3E9g cf2tVG"
          >
            <div className="cfAdwL cf7ddU" dir="ltr">
              <div className="cf1XPf cf2L3T cf3ItN">
                <span className="cf38KE cf1Rhi">
                  <div dir="ltr" className="cf3m5k cf2XkG">
                    <div
                      className="intro-content__lang"
                      data-cookiefirst-accent-color="true"
                    ></div>
                    <div
                      className="intro-content__link"
                      data-cookiefirst-accent-color="true"
                    ></div>
                  </div>
                  We use cookies
                </span>
                <p>
                  We may place these for analysis of our visitor data, to
                  improve our website, show personalised content and to give you
                  a great website experience. For more information about the
                  cookies we use open the settings.
                </p>
              </div>
              <div className="cf2L3T cfysV4 cf2mE1">
                <div className="cf1QhF cf1IKf"></div>
                <div className="cf3Tgk cf1IKf" dir="ltr">
                  <div className="cf1YU1 cfNq4w">
                    <button
                      data-cookiefirst-outline-accent-color="true"
                      data-cf-action="accept"
                      tabIndex="1"
                      className="cf2Lf6"
                      data-cookiefirst-button="primary"
                      aria-label="Ok, continue"
                      onClick={this.Okcookies}
                    >
                      <span className="cf1y60">Ok, continue</span>
                    </button>
                  </div>
                  <div className="cf1YU1 cf2MAH">
                    <button
                      data-cookiefirst-outline-accent-color="true"
                      data-cf-action="reject"
                      tabIndex="1"
                      className="cf2Lf6"
                      data-cookiefirst-button="secondary"
                      aria-label="Deny"
                      onClick={this.Deny}
                    >
                      <span className="cf1y60">Deny</span>
                    </button>
                  </div>
                  <div className="cf1YU1 cf2MAH">
                    <button
                      data-cookiefirst-outline-accent-color="true"
                      data-cf-action="adjust"
                      tabIndex="1"
                      className="cf2Lf6"
                      data-cookiefirst-button="secondary"
                      aria-label="No, adjust"
                      onClick={this.adjust}
                    >
                      <span className="cf1y60">Close</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );

    if (this.state.hasCookie) {
      html = "";
    }
    // this.checkCookie()
    return html;
  }
}

export default AgreeCookies;



// WEBPACK FOOTER //
// ./src/Components/AgreeCookies/AgreeCookies.js